import React, { Fragment } from "react";
import { useForm } from "react-hook-form";
import {
  Row,
  Col,
  CardHeader,
  CardBody,
  CardFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Container,
  Button,
} from "reactstrap";
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import JobSearch from "../../Components/Jobseeker/JobSearch";
import YourCandidateSearch from "../../Components/Recruiter/YourCandidateSearch";
const YourCandidateSearchPage = () => {
  return (
    <Fragment>
      <Breadcrumbs
        title="Search Candidate ( Your Candidate)"
        mainTitle="Search Candidate ( Your Candidate)"
      />
      <Container fluid={true}>
        <YourCandidateSearch />
      </Container>
    </Fragment>
  );
};

export default YourCandidateSearchPage;
